import {Alert, Card} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {LeasingMatrix} from './LeasingMatrix';
import {LeasingCellCoordinates} from './types/LeasingCellCoordinates';

interface LeasingRateMatrixSectionProps {
  vehicleLeasingBody: SaveSaleVehicleLeasingBody;
  currency: string;
  isReadOnly: boolean;
  hasActiveVariantError: boolean;
  onEditCell: (coordinates: LeasingCellCoordinates) => void;
}

export function LeasingRateMatrixSection(props: LeasingRateMatrixSectionProps) {
  return (
    <Card
      title={i18n.t('page.vehicle.financingAndLeasing.leasingRateMatrix')}
      titleIcon="editor/table_chart"
      variant="inlineGrey"
    >
      <VStack spacing={3}>
        <LeasingMatrix
          vehicleLeasingBody={props.vehicleLeasingBody}
          currency={props.currency}
          isReadOnly={props.isReadOnly}
          onEditCell={props.onEditCell}
        />
        <Show when={props.hasActiveVariantError}>
          <Alert
            type="inline"
            variant="error"
            title={i18n.t(
              'page.vehicle.financingAndLeasing.validation.activeVariantRequiredTitle',
              {product: i18n.t('entity.vehicle.labels.leasing')}
            )}
            message={i18n.t(
              'page.vehicle.financingAndLeasing.validation.activeVariantRequiredMessage',
              {action: i18n.t('page.vehicle.financingAndLeasing.setAsActiveVariant')}
            )}
          />
        </Show>
        <Text size="xSmall" color="secondary">
          {i18n.t('page.vehicle.financingAndLeasing.grossRateHint')}
        </Text>
      </VStack>
    </Card>
  );
}
